/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentGatewayTransactionSummary { 
    authorizedAmount?: number | null;
    amount?: number | null;
    cardType?: string | null;
    customerFirstName?: string | null;
    customerLastName?: string | null;
    issuerResponseCode?: string | null;
    issuerResponseMessage?: string | null;
    gatewayResponseCode?: string | null;
    paymentType?: string | null;
    transactionDate?: string | null;
    transactionStatus?: string | null;
    transactionId?: string | null;
    depositAmount?: number | null;
    depositCurrency?: string | null;
    depositDate?: string | null;
    depositReference?: string | null;
    depositType?: string | null;
    feeAmount?: number;
}

